// TL Upsell-Modal (A/B) — docs/69
// Markup + Konfiguration: snippets/tl-upsell-modal.liquid (nur auf PDPs mit gepflegtem Modal).
// Abzweig: assets/product-notification-drawer.js, variant:add-Handler. Der Drawer fragt
// isEligible() synchron (vor dem Cart-Drawer) und shouldShowForCart() nach /cart.js.
//
// Arme: ABlyft setzt html.ab-upsell-modal (Variante). Ohne Klasse = Standard-Drawer.
// Events (beide Arme, nur auf Testprodukten): tl-upsell-shown / -accepted / -declined,
// pro Upsell-Add zusätzlich tl-upsell-added (every) + tl-upsell-value (revenue, Euro) und die
// Warenkorb-Attribute tl_upsell (modal/drawer) + tl_upsell_items (Namen) -> recordUpsell().
// Upsell-Rabatt (docs/73, A/B-fähig): cfg.discountMode "off" | "ab" | "always". Gilt der Rabatt
// (bei "ab" nur mit html.ab-upsell-discount), bekommt die Zeile _tl_upsell = cfg.upsellMark
// (Handle des Hauptprodukts) für die Discount Function; Quelle im Attribut = "modal-rabatt".


(function () {
  'use strict';

  var cfg = window.TL && window.TL.upsellModalConfig;
  var modal = document.querySelector('[data-tl-upsell-modal]');
  if (!cfg || !modal || (window.TL.upsellModal && window.TL.upsellModal._ready)) return;

  var VARIANT_CLASS = 'ab-upsell-modal';
  var DISCOUNT_CLASS = 'ab-upsell-discount';

  // QA-Schalter ohne Konsole/ABlyft: ?tl_upsell_qa=1 an eine Testprodukt-URL hängen -> Modal-Arm,
  // ?tl_upsell_qa=2 -> Modal-Arm mit Upsell-Rabatt, jeweils für den Rest der Browser-Sitzung
  // (sessionStorage); ?tl_upsell_qa=0 schaltet ab. Greift nur auf Testprodukten, weil diese Datei
  // nur dort lädt. Kein Einfluss auf ABlyft-Zuweisung/Events.
  try {
    var qaParam = new URLSearchParams(window.location.search).get('tl_upsell_qa');
    if (qaParam === '0' || qaParam === '1' || qaParam === '2') sessionStorage.setItem('tl_upsell_qa', qaParam);
    var qa = sessionStorage.getItem('tl_upsell_qa');
    if (qa === '1' || qa === '2') {
      document.documentElement.classList.add(VARIANT_CLASS);
      if (qa === '2') document.documentElement.classList.add(DISCOUNT_CLASS);
      console.info('[Upsell-Modal] QA-Modus aktiv (tl_upsell_qa=' + qa + ') — ?tl_upsell_qa=0 zum Beenden');
    }
  } catch (e) { /* sessionStorage gesperrt (Privatmodus o. ä.) -> kein QA-Modus */ }
  // Nach jedem Schliessen öffnet der Cart-Drawer (CTA, "Nein danke", ✕, ESC, Klick daneben):
  // Das Hauptprodukt liegt da schon im Warenkorb.
  var resolved = false;

  function track(name) {
    window.ablyft = window.ablyft || [];
    window.ablyft.push({ eventType: 'custom', eventName: name });
  }

  function drawerApi() {
    return window._tlUpsellDrawerApi || null;
  }

  function openCartDrawer() {
    var api = drawerApi();
    if (api) return api.openCartDrawer();
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
  }

  // Ein Upsell-Add erfassen (Modal UND Standard-Drawer auf Testprodukten, docs/69 "Tracking").
  // Attribute erscheinen in der Bestellung unter "Zusätzliche Details" und im CSV-Export
  // ("Note Attributes"). Fehler hier dürfen den Kaufablauf nie stören -> nur Konsole.
  function recordUpsell(source, name, priceCents) {
    track('tl-upsell-added');
    window.ablyft = window.ablyft || [];
    window.ablyft.push({ eventType: 'revenue', eventName: 'tl-upsell-value', eventValue: (Number(priceCents) || 0) / 100 });

    var api = drawerApi();
    var cartFetch = api ? api.cartFetch : function (url, options) {
      return fetch(url, options).then(function (r) { if (!r.ok) throw new Error('Cart request failed: ' + r.status); return r.json(); });
    };

    return cartFetch('/cart.js')
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        var sources = attrs.tl_upsell ? String(attrs.tl_upsell).split(',') : [];
        if (sources.indexOf(source) === -1) sources.push(source);
        var items = attrs.tl_upsell_items ? String(attrs.tl_upsell_items).split(', ') : [];
        if (name) items.push(String(name).replace(/,/g, ' '));
        return cartFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { tl_upsell: sources.join(','), tl_upsell_items: items.join(', ') } })
        });
      })
      .catch(function (error) {
        console.warn('[Upsell-Modal] Warenkorb-Attribut nicht gesetzt:', error);
      });
  }

  // Gilt der Upsell-Rabatt gerade? Zum Klickzeitpunkt geprüft, ABlyft setzt die Klasse ggf. spät.
  function discountActive() {
    return cfg.discountMode === 'always' ||
      (cfg.discountMode === 'ab' && document.documentElement.classList.contains(DISCOUNT_CLASS));
  }

  function isEligible(addedProductId) {
    return document.documentElement.classList.contains(VARIANT_CLASS) &&
      Number(addedProductId) === cfg.productId;
  }

  // Kein Modal, wenn das Upsell-Produkt (irgendeine Variante) oder bei einem
  // Angebots-Duplikat das Original schon im Warenkorb liegt.
  function shouldShowForCart(cart) {
    var blocked = [cfg.upsellProductId, cfg.originalProductId].filter(Boolean);
    return !(cart && cart.items || []).some(function (item) {
      return blocked.indexOf(item.product_id) !== -1;
    });
  }

  function show() {
    resolved = false;
    customElements.whenDefined('x-modal').then(function () {
      modal.show();
      track('tl-upsell-shown');
    });
  }

  function close() {
    modal.hide();
  }

  function accept(ctaWrap) {
    if (ctaWrap.classList.contains('is-loading')) return;
    ctaWrap.classList.add('is-loading');

    var api = drawerApi();
    var discounted = discountActive();
    var line = { id: cfg.variantId, quantity: 1 };
    // Markierung nur, wenn der Rabatt gilt (Properties trennen Warenkorbzeilen)
    if (discounted) line.properties = { _tl_upsell: cfg.upsellMark };
    var body = JSON.stringify({ items: [line] });
    var request = api
      ? api.cartFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body })
      : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body })
          .then(function (r) { if (!r.ok) throw new Error('Cart request failed: ' + r.status); return r.json(); });

    request
      .then(function () {
        resolved = true;
        track('tl-upsell-accepted');
        return discounted
          ? recordUpsell('modal-rabatt', cfg.upsellName, cfg.discountPrice)
          : recordUpsell('modal', cfg.upsellName, cfg.variantPrice);
      })
      .then(function () {
        // Cart-Drawer-Inhalt (inkl. Geschenkstufen) per cart:refresh neu rendern, Zähler direkt
        // setzen. NICHT api.updateCartCount: dessen cart:change ohne `sections` lässt Prestiges
        // CartDrawer.onCartChange werfen (TypeError ... '__cart-drawer').
        var refresh = api ? api.refreshCart() : (document.dispatchEvent(new CustomEvent('cart:refresh')), fetch('/cart.js').then(function (r) { return r.json(); }));
        return refresh.then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('cart-count').forEach(function (el) { el.itemCount = cart.item_count; });
        });
      })
      .catch(function (error) {
        // Hauptprodukt liegt trotzdem im Warenkorb -> weiter zum Warenkorb statt Fehlermeldung
        console.error('[Upsell-Modal] Hinzufügen fehlgeschlagen:', error);
      })
      .then(function () {
        ctaWrap.classList.remove('is-loading');
        close();
      });
  }

  modal.addEventListener('click', function (event) {
    var ctaWrap = event.target.closest('[data-tl-upsell-accept]');
    if (ctaWrap && event.target.closest('button, a')) {
      event.preventDefault();
      accept(ctaWrap);
      return;
    }
    if (event.target.closest('[data-tl-upsell-decline]')) {
      event.preventDefault();
      resolved = true;
      track('tl-upsell-declined');
      close();
    }
  });

  // Prestige feuert dialog:after-hide nach der Ausblend-Animation -> erst dann den
  // Cart-Drawer öffnen, sonst kollidieren Fokusfalle und Scroll-Sperre beider Dialoge.
  modal.addEventListener('dialog:after-hide', function () {
    if (!resolved) {
      resolved = true;
      track('tl-upsell-declined'); // ✕ / Overlay / ESC
    }
    openCartDrawer();
  });

  window.TL.upsellModal = {
    _ready: true,
    isEligible: isEligible,
    shouldShowForCart: shouldShowForCart,
    show: show,
    track: track,
    recordUpsell: recordUpsell
  };
})();
